import React from "react";
import Image1 from '../assets/Image/e-commerce.png';
import Image2 from '../assets/Image/event.webp';
import Image3 from '../assets/Image/matrimony.jpg';
import Image4 from '../assets/Image/gy.webp';

const projects = [
  { title: "Matrimony Website", img: Image3, link: "#" },
  { title: "Gym Website", img: Image4, link: "#" },
  { title: "E-commerce Store", img: Image1, link: "#" },
  { title: "Event Website", img: Image2, link: "#" },
];

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6 max-w-7xl">
        <h2 className="text-5xl font-extrabold text-center text-gray-900 mb-16 tracking-tight">
          Our Projects
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {projects.map((project, index) => (
            <div
              key={index}
              className="relative bg-white rounded-3xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden cursor-pointer transform hover:-translate-y-1"
              style={{ willChange: 'transform' }}
              aria-label={`View project: ${project.title}`}
            >
              <div className="overflow-hidden rounded-t-3xl">
                <img
                  src={project.img}
                  alt={project.title}
                  className="w-full h-56 object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-semibold mb-2 text-gray-900">
                  {project.title}
                </h3>
                <a
                  href={project.link}
                  className="inline-block text-indigo-600 font-medium hover:underline text-base"
                  tabIndex={0}
                >
                  View Project
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
